<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>
    
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">      
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-6 col-md-10 mb-5">
              <h1 class="display-3 text-white">{{controller.title}}</h1>
              <p class="text-white mt-0">Listado de leads</p>
            </div>
          </div>
          <div class="card">
            <my-spinner :loading="loading"/>
            <div class="card-body">              
              <div class="row row-search-campaign">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="input-formulario">Clientes</label>
                    <v-select
                      style="width:100%;"
                      placeholder="Buscar cliente"
                      :options="clients"
                      label="caption"
                      v-model="clientSelected"
                    >
                      <span slot="no-options">No hay resultados disponibles</span>
                    </v-select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="input-campaign">Campaña</label>
                    <v-select
                      style="width:100%;"
                      placeholder="Buscar campaña"
                      :options="campaigns"
                      label="caption"
                      v-model="campaignSelected"
                    >
                      <span slot="no-options">No hay resultados disponibles</span>
                    </v-select>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label for="input-campaign">Fecha Inicial</label>
                    <input type="date" class="form-control" v-model="fecha_inicial">
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label for="input-campaign">Fecha Final</label>
                    <input type="date" class="form-control" v-model="fecha_final">
                  </div>
                </div>
                <div class="col-lg-1">
                  <div class="form-group">                    
                    <label
                      for="input-campaign"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                    <button
                      @click="getLeads()"
                      type="button"
                      class="btn btn-success"
                      :disabled="btndisabled"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">      
      <div class="row">
        <div class="col">
          <template v-if="generals.tmp.length > 0">
            <div class="card shadow">
              <div class="card-header border-0">
                <div class="row">
                  <div class="col-sm-6">
                    <h3 class="mb-0">Listado de {{xls.filename}}</h3>
                  </div>
                  <div class="col-sm-6 text-right">
                    <download-excel
                      class="btn btn-secondary btn-sm"
                      :data="xls.xlsData"
                      :fields="xls.xlsFields"
                      :name="xls.filename + xls.ext"
                      :title="xls.filename"
                    >
                      <img src="@/assets/img/excel-ico.png" width="24px" alt="Exportar"> Exportar
                    </download-excel>
                  </div>
                </div>
              </div>

              <div class="table-responsive">                
                <table class="table align-items-center table-flush table-hover" id="tblData">
                  <thead class="thead-light">
                    <tr>
                      <th v-for="res in generals.tmp[0].respuesta" :key="res.id">{{res.caption}}</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                      <template v-for="resultado in generals.tmp">
                        <tr :key="resultado.id">
                          <th
                            v-for="res in resultado.respuesta"
                            :key="res.id"
                          >{{res.respuesta.substring(0,50)}}</th>
                          <th>{{formatDate(resultado.id)}}</th>
                        </tr>
                      </template>
                  </tbody>
                </table>
              </div>
              <div class="card-footer py-4" v-if="generals.data.length > generals.pagination.pag">
                <b-pagination
                  size="md"
                  align="right"
                  :hide-goto-end-buttons="true"
                  :total-rows="generals.data.length"
                  v-model="generals.pagination.currentPage"
                  :per-page="generals.pagination.pag"
                ></b-pagination>
              </div>
            </div>
          </template>
          <template
            v-if="leads.campana && generals.tmp.length == 0"
          >
            <div class="card shadow text-center">
              <div class="card-header border-0">No hay resultado para la campaña seleccionada</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import DfpServices from "@/services/dfp.services";
import sysMsgs from "@/helpers/system.message";
import _ from "underscore";
import moment from "moment";

export default {
  name: "Leads",
  components: {
    vSelect
  },
  data() {
    return {
      controller: {
        title: "Leads",
        mainRouter: "/marketing/leads"
      },
      loading: true,
      generals: {
        data: [],
        tmp: [],
        pagination: {
          pag: 15,
          currentPage: 1
        }
      },
      leads: {},
      btndisabled: true,
      search: {
        cliente: 0,
        campana: 0,
        fecha_inicial: null,
        fecha_final: null
      },
      clients: [],
      clientSelected: null,
      campaigns: [],
      campaignSelected: null,
      fecha_inicial: null,
      fecha_final: null,
      xls: {
        xlsData: [],
        xlsFields: {},
        filename: null,
        ext: ".xls"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  watch: {
    clientSelected: {
      handler(data) {
        this.leads = {};
        this.generals.tmp = [];
        this.generals.data = [];

        this.campaigns = [];
        this.campaignSelected = null;
        if (data) {
          this.getCampaigns(data.id);
        } else {
          this.campaignSelected = null;
          this.btndisabled = true;
        }
      }
    },
    campaignSelected: {
      handler(data) {
        this.leads = {};
        this.generals.tmp = [];
        this.generals.data = [];
        if (data) {
          this.search.cliente = this.clientSelected.id;
          this.search.campana = data.id;
          this.btndisabled = false;
        } else {          
          this.btndisabled = true;
        }
      }
    },
    fecha_inicial: {
      handler(data) {
        this.search.fecha_inicial = data ? data.split("-").join("") : null;
      }
    },
    fecha_final: {
      handler(data) {
        this.search.fecha_final = data ? data.split("-").join("") : null;
      }
    },
    "generals.pagination.currentPage": {
      handler(data) {
        this.paginationFilter(this.generals.data, data);
      }
    }
  },
  methods: {
    getClientes() {
      this.loading = true;
      DfpServices.filtros
        .getClientes()
        .then(response => {
          this.clients = response.data.lista;
          this.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
    },
    getCampaigns(id) {
      this.loading = true;
      DfpServices.filtros
        .getCampana(id)
        .then(response => {
          this.campaigns = response.data.lista;
          this.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
    },
    getLeads() {
      this.loading = true;
      DfpServices.Leads.getAll(this.search)
        .then(response => {
          this.leads = response.data;
          this.generals.pagination.currentPage = 1;
          this.generals.data = response.data.campana[0].resultado;
          this.paginationFilter(this.generals.data, this.generals.pagination.currentPage);

          let xls = {
            xlsData: [],
            xlsFields: {},
            filename: null
          };

          _.extend(this.xls, xls);

          if (_.first(this.leads.campana).resultado.length > 0) {
            _.each(
              _.first(this.leads.campana).resultado,
              (data, index) => {
                this.xls.filename = this.leads.campana[0].caption;
                this.xls.xlsData.push({
                  id: index,
                  fecha: this.formatDate(data.id)
                });
                _.each(data.respuesta, (data, _index) => {
                  _.extend(this.xls.xlsFields, {
                    [data.caption]: data.caption
                  });
                  _.extend(_.findWhere(this.xls.xlsData, { id: index }), {
                    [data.caption]: data.respuesta
                  });
                });
                _.extend(this.xls.xlsFields, { Fecha: "fecha" });
              }
            );
          }

          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          sysMsgs.getResponseMessage(error.response);
        });
    },
    formatDate(fecha) {
      return moment(parseInt(fecha)).format("DD-MM-YYYY");
    },
    paginationFilter(data, start) {
      start = start - 1;
      this.generals.tmp = data.slice(
        this.generals.pagination.pag * start,
        this.generals.pagination.pag * start + this.generals.pagination.pag
      );
    }
  },
  created() {
    this.getClientes();
  }
};
</script>
